import { normalizeStringForSearch } from './formatters';

/**
 * Busca en la lista de ubicaciones de la app (ciudades, localidades, barrios)
 * la primera coincidencia que encaje con el texto enviado por la IA.
 */
export const resolveFirstLocationMatch = (aiLocationText: string, allAvailableLocations: { name: string }[]): string | null => {
    if (!aiLocationText || !allAvailableLocations.length) return null;

    const normalizedTarget = normalizeStringForSearch(aiLocationText);
    const searchWords = normalizedTarget.split(' ').filter(w => w.length > 0);
    
    // 1. Intentar coincidencia exacta primero
    const exactMatch = allAvailableLocations.find(l => normalizeStringForSearch(l.name) === normalizedTarget);
    if (exactMatch) return exactMatch.name;

    // 2. Aplicar misma lógica que el buscador manual:
    // - Filtrar por presencia de todas las palabras
    // - Ordenar por jerarquía (Ciudad -> Localidad -> Barrio) y Alfabéticamente
    const sortedMatches = [...allAvailableLocations]
        .filter(l => {
            const normalizedName = normalizeStringForSearch(l.name);
            return searchWords.every(word => normalizedName.includes(word));
        })
        .sort((a, b) => {
            const levelA = a.name.split(',').length;
            const levelB = b.name.split(',').length;
            if (levelA !== levelB) return levelA - levelB;
            return a.name.localeCompare(b.name);
        });
    
    return sortedMatches.length > 0 ? sortedMatches[0].name : null;
};